export function parseTags(raw = "") {
  const text = String(raw);

  const getBlock = (start, end) => {
    const s = text.indexOf(start);
    if (s === -1) return "";
    const e = text.indexOf(end, s + start.length);
    if (e === -1) return "";
    return text.slice(s + start.length, e).trim();
  };

  const getAllBlocks = (start, end) => {
    const results = [];
    const regex = new RegExp(`${start.replace(/[<>]/g, '\\$&')}([\\s\\S]*?)${end.replace(/[<>]/g, '\\$&')}`, 'g');
    let match;
    while ((match = regex.exec(text)) !== null) {
      const content = match[1].trim();
      if (content) results.push(content);
    }
    return results;
  };

  const passage = getBlock("<<<BEGIN PASSAGE>>>", "<<<END PASSAGE>>>");
  const conclusion = getBlock("<<<BEGIN CONCLUSION>>>", "<<<END CONCLUSION>>>");

  const reasonsBlock = getBlock(
    "<<<BEGIN SUPPORTING REASONS>>>",
    "<<<END SUPPORTING REASONS>>>"
  );

  // Unnumbered reasons
  const reasons = [];
  if (reasonsBlock) {
    const reasonRegex = /<<<BEGIN REASON>>>([\s\S]*?)<<<END REASON>>>/g;
    let match;
    while ((match = reasonRegex.exec(reasonsBlock)) !== null) {
      const reasonText = match[1].trim();
      if (reasonText) reasons.push(reasonText);
    }
  }

  // Dialog completion detection
  const dialogCompleted = text.includes("<<<BEGIN DIALOG COMPLETED");
  const completionStatus = dialogCompleted
    ? text.includes("<<<BEGIN DIALOG COMPLETED SUCCESSFULLY>>>")
      ? "success"
      : "failure"
    : null;

  // Success/Failure feedback text
  const successText = getBlock("<<<START SUCCESS>>>", "<<<END SUCCESS>>>");
  const summary = getBlock("<<<BEGIN SUMMARY>>>", "<<<END SUMMARY>>>");

  // Grab all examples
  const examples = getAllBlocks("<<<BEGIN EXAMPLE>>>", "<<<END EXAMPLE>>>");

  // Completion message (plain text after <<<DIALOG COMPLETED ... >>>)
  const completionMessage = dialogCompleted
    ? text
        .split(/<<<BEGIN DIALOG COMPLETED.*?>>>/)
        .pop()
        .replace(/<<<BEGIN EXAMPLE>>>[\s\S]*?<<<END EXAMPLE>>>/g, "")
        .trim()
    : "";

  // Task (only if dialog is not completed)
  const task = dialogCompleted
    ? ""
    : text
        .replace(/<<<BEGIN PASSAGE>>>[\s\S]*?<<<END PASSAGE>>>/g, "")
        .replace(/<<<BEGIN CONCLUSION>>>[\s\S]*?<<<END CONCLUSION>>>/g, "")
        .replace(/<<<BEGIN SUPPORTING REASONS>>>[\s\S]*?<<<END SUPPORTING REASONS>>>/g, "")
        .trim();

  return {
    passage,
    conclusion,
    reasons,
    task,
    dialogCompleted,
    completionStatus,
    successText,
    summary,
    examples,
    completionMessage,
  };
}
